import { format } from '@legacy/js/date/date-fns.js';

export default class BatchSendLetterDraft {
    static ACTION_NAME = 'SendLetterDraft';

    constructor(entity) {
        this.action = BatchSendLetterDraft.ACTION_NAME;
        this.entity = entity;
        this.isDraftSet = false;
        this.addToExchangeFolder = false;
        this.subject = '';
        this.attachments = [];
        this.referenceDate = format(new Date(), 'dd.MM.yyyy');
        this.senderEmail = null;
    }

    serialize() {
        return {
            action: this.action,
            entity: this.entity,
            ids: this.ids,
            isDraftSet: this.isDraftSet,
            draftId: this.isDraftSet ? null : this.draft?.id,
            draftSetId: this.isDraftSet ? this.draftSet?.id : null,
            subject: this.subject,
            senderEmail: this.senderEmail?.email,
            attachmentIds: this.attachments.map((x) => x.id),
            message: this.message,
            referenceDate: this.referenceDate,
            addToExchangeFolder: this.addToExchangeFolder,
        };
    }

    isValid() {
        if (!this.ids || this.ids.length === 0) {
            return false;
        }
        if (!this.subject || this.subject === '') {
            return false;
        }
        if (!this.draft && !this.draftSet) {
            return false;
        }
        if (!this.referenceDate) {
            return false;
        }
        if (!this.senderEmail) {
            return false;
        }
        return true;
    }
}
